import restCrudReducer from '../../../np-crud/store/restCrudReducer';
import * as actionTypes from './actionTypes';

const [crudInitialState, crudReducer] = restCrudReducer({
    pluginName: 'LOGISTIC',
    entityName: 'COLLI',
});

const restoreInitialState = {
    restored: null,
    restoring: false
}

const initialState = {
    ...crudInitialState,
    ...restoreInitialState,
    restoring: false,
    deleting: false,
    saving: false,
    columns: []
};

const restoreInit = state => {
    return {
        ...state,
        ...restoreInitialState
    };
};

const restoreStart = state => {
    return { ...state, restoring: true };
};

const restoreSuccess = (state, action) => {
    return {
        ...state,
        colliRestored: action.colliRestored,
        restoring: false
    };
};

const restoreFail = state => {
    return {
        ...state,
        restoring: false
    };
};

const reducer = (state = initialState, action) => {
    // Handle CRUD actions
    const newState = crudReducer(state, action);
    // If CRUD reducer handled the action
    if (newState !== null) {
        return newState;
    }
    // Handle other actions
    switch (action.type) {
        case 'CORE|LOGOUT_SUCCESS':
        case 'CORE|CORE_SET_ACTIVE_CUSTOMER_SUCCESS':
            return initialState;
        case actionTypes.RESTORE_COLLI_INIT:
            return restoreInit(state, action);
        case actionTypes.RESTORE_COLLI_START:
            return restoreStart(state, action);
        case actionTypes.RESTORE_COLLI_SUCCESS:
            return restoreSuccess(state, action);
        case actionTypes.RESTORE_COLLI_FAIL:
            return restoreFail(state, action);
        default:
            return state;
    }
};

export default reducer;
